module.exports = __webpack_public_path__ + "img/B2.78f9cc63.svg";